module.exports = __webpack_public_path__ + "static/img/promotekstil.0196259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/promotekstil.png
// module id = lIT7
// module chunks = 0